import { ANNOUNCEMENT_USER_TYPE_TAG_NAMES } from '../../../../../../Model/Announcement';
import { UserCategory } from '../../../../../../../Model/User';

const getGenericCommunity = (userCategory) => {
  const tag = ANNOUNCEMENT_USER_TYPE_TAG_NAMES[userCategory]
    || ANNOUNCEMENT_USER_TYPE_TAG_NAMES[UserCategory.OTHER];
  return { id: tag.value, name: tag.label };
};

/**
 * One generic community per category the client holds, deduped — FREE_CLIENTS and an
 * unresolved product both map to 1:1, so a client can hold two categories and land on
 * the same community twice.
 *
 * @param {Set<string>} userCategories - The categories held with this coach.
 * @return {Array<{id: string, name: string}>}
 */
const getGenericCommunities = (userCategories) => {
  const communities = [...(userCategories?.size ? userCategories : [UserCategory.OTHER])]
    .map(getGenericCommunity);
  return [...new Map(communities.map((community) => [community.id, community])).values()];
};

export {
  getGenericCommunities,
  getGenericCommunity,
};
